import $ from 'jquery'
window.$ = window.jQuery = $;

import './bootstrap'

// NProgress

import nprogress from 'nprogress';
window.NProgress = nprogress;

// App

require('./app/nbrogress.js');
require('./app/tooltip.js');
